<template>

    <div>
        <w-toolbar shadow class="py1">
            <div id="placepicker">
                <div width="105%" height="75" @click="gotHome()">
                    <!-- <svg id="logo" width="105%" height="75"> -->

                    <!-- <SvgIcon name="Whirlpool"></SvgIcon> -->
                    <div class="container">
                        <img src="https://www.bekoeurope.com/media/flgpimi4/beko_beyaz_white.png" height="75">
                        <h1 class="title">MultiService</h1>
                    </div>
                    <!-- </svg> -->
                </div>
            </div>
            <div class="spacer"></div>

            <w-button icon="mdi mdi-cart " text lg class="ml3" @click="openDrawer = 'bottom'" color="white" outline>

            </w-button><span style="color : white"> {{ cartItems }}</span>
            <w-transition-expand y>
                <div v-if="toggleSExpandY">Shopping Cart</div>
            </w-transition-expand>

            <w-button icon="mdi mdi-account " text lg class="ml3" @mouseover="toggleAExpandY = !toggleAExpandY"
                color="white" outline></w-button>
            <w-transition-expand y>
                <button v-if="toggleAExpandY" @click="logout">Logout</button>
            </w-transition-expand>

        </w-toolbar>

    </div>

    <w-drawer :[position]="true" v-model="openDrawer" width="460px">

        <ShoppingCart></ShoppingCart>
    </w-drawer>





</template>
<script>
import { ref, watch, shallowRef } from "vue";

import router from "@/router";
import { googleLogout } from "vue3-google-login";
import SvgIcon from '../components/SvgIcon.vue';
import ShoppingCart from '../views/ShoppingBasketView.vue'
import { useCartStore } from '../store/cart'
export default {
    name: "App",
    components: {
        SvgIcon, ShoppingCart
    },

    data() {
        const cartItems = ref(useCartStore().getItems().length)
        const logout = () => {
            googleLogout()
            router.push('/login')
        }
        watch(useCartStore(), (newValue, oldValue) => {
            console.log(newValue);
            cartItems.value = newValue.cartItems.length

            // console.log("Selection Changed", newValue.selection);
        })
        function gotHome() {
            router.push('/')
        }
        const openDrawer = false
        return {
            toggleAExpandY: false,
            toggleSExpandY: false,
            logout,
            gotHome,
            openDrawer,
            cartItems

        };
    },
    computed: {
        position() {
            return this.openDrawer
        }
    }
};

</script>

<style scoped>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #103861;
}

.change-my-color {
    filter: invert(48%) sepia(69%) saturate(2476%) hue-rotate(7deg) brightness(105%) contrast(169%);

}

.w-toolbar {
    background-color: #021d48;
}

.container {
    display: flex;
    align-items: center;
    justify-content: center
}

.title {
    color: #ffffff;
    padding-left: 20px;
}

.svg-container {
    display: inline-block;
    position: relative;
    width: 100%;

    vertical-align: top;
    overflow: hidden;
}

.w-app .primary--bg {
    background-color: #021d48;
}

.transition-toggle {
    margin: 12px 24px 12px 0;
    width: 7.7em;
}

.transition-box {
    background-color: #eee;
    border: 1px solid #ddd;
    border-radius: 3px;
    padding: 1em;
    width: 14em;
    text-align: center;
}
</style>
